import {
    DataGridPro,
    GridColDef,
    GridFilterModel,
} from "@mui/x-data-grid-pro";
import {useEffect} from "react";
import {useAppContext} from "@/contexts/AppContext.tsx";
import {grey} from "@mui/material/colors";

export type {GridColDef, GridFilterModel};

export default function DataGridSimple({ rows, columns, initialState, sx, ...props}: any) {
    // test clear console.log on DataGrid initialized
    useEffect(() => {
        console.clear()
    }, []);

    return (
        <DataGridPro
            autoHeight
            rows={rows}
            columns={columns}
            density="compact"
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 20,
                    },
                },
                ...initialState,
            }}
            pagination
            pageSizeOptions={[10, 20, 50, 100]}
            // checkboxSelection
            disableRowSelectionOnClick
            sx={{
                border: "none",
                borderRadius: 0,
                ".MuiDataGrid-main": {
                    "& :last-child[style='position: absolute; pointer-events: none; color: rgba(130, 130, 130, 0.62); z-index: 100000; width: 100%; text-align: center; bottom: 50%; right: 0px; letter-spacing: 5px; font-size: 24px;']": {
                        color: 'transparent ! important'
                    }
                },
                ".MuiDataGrid-columnHeaders": {
                    borderRadius: 0,
                    backgroundColor: "grey.200",
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontSize: 13,
                    },
                },
                ".MuiDataGrid-cellContent": {
                    fontSize: 13,
                },
                ".MuiDataGrid-selectedRowCount": {
                    fontSize: 13,
                },
                ".MuiDataGrid-rowCount": {
                    fontSize: 13
                },
                ".MuiTablePagination-root .MuiTablePagination-input, .MuiTablePagination-root .MuiTablePagination-selectLabel, .MuiTablePagination-root .MuiTablePagination-displayedRows":
                    {
                        fontSize: 13,
                    },
                ...sx,
            }}
            {...props}
        />
    );
}

export function DataGridSimpleStyled({rows, columns, ...props}: any) {
    const {uiVisual} = useAppContext();

    return (
        <DataGridSimple
            {...props}
            rows={rows}
            columns={columns}
            disableColumnMenu
            sx={{
                ".MuiDataGrid-overlay": {
                    fontSize: 13
                },
                ".MuiDataGrid-columnHeaders": {
                    borderRadius: 0,
                    backgroundColor: uiVisual === 'classic' ? grey[200] : '#E7EEFF',
                    borderColor: uiVisual === 'classic' ? grey[200] : '#EBEDFA',
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontSize: 13,
                    },
                },
                ".MuiDataGrid-row:hover": {
                    backgroundColor: uiVisual === 'classic' ? grey[50] : '#EEF4FF'
                },
                ".MuiDataGrid-cell": {
                    borderColor: uiVisual === 'classic' ? grey[200] : '#EBEDFA'
                },
                ".MuiDataGrid-footerContainer": {
                    bgcolor: uiVisual === 'classic' ? grey[100] : "#F2F6FF",
                    borderBottomLeftRadius: 1,
                    borderBottomRightRadius: 1,
                    "&.MuiDataGrid-withBorderColor": {
                        borderColor: uiVisual === 'classic' ? grey[200] : '#E9ECFB'
                    }
                }
            }}
        />
    )
}